import React, { useEffect, useState } from "react"
import { Container, CardTitle, Button } from "reactstrap"
import comingSoon from "../../../assets/images/coming-soon.svg"
import { Link, useNavigate } from "react-router-dom"
import { useLazyGetPendingProfileUpdateRequestQuery } from "store/api/profile/profile.api"
import UpdateProfileProgressBar from "./updateProfileProgressBar"
import LoaderComponent from "components/loader"
import { useLazyGetKycDataQuery } from "store/api/kyc/kyc"
import BankDetails from "./bankDetails"
import IDVerification from "./IDVerification"
import Signature from "./signature"
import CaptureSelfie from "./captureSelfie"
import AuthorisedSignatory from "./authorisedSignatory"
import KycAuthorityLetter from "./authorityLetter"
import KycFinalStep from "./kycFinalStep"
import KycFinalStepBusiness from "./KycFinalStepBusiness"
import { useSelector } from "react-redux"
import KYCComplete from "./KYCComplete"
import CompanyDetails from "./companyDetails"
import BusinessAdditionalDetails from "./businessAdditionalDetails"
import AdditionalDetails from "./additionalDetails"

const ProfileUpdate = () => {
  const [getPendingProfileRequest, { isFetching }] =
    useLazyGetPendingProfileUpdateRequestQuery()
  const navigate = useNavigate()
  const [currentStep, setCurrentStep] = useState("")
  const [updateRequest, setUpdateRequest] = useState(null)
  const [kycData, setKycData] = useState(null)
  const [getResult, { isFetching: isGetting }] = useLazyGetKycDataQuery()
  const { user } = useSelector((state) => state.user)

  useEffect(() => {
    getKycData()
    pendingProfileRequest()
  }, [])

  const pendingProfileRequest = async () => {
    try {
      const { success, data } = await getPendingProfileRequest().unwrap()
      if (success) {
        setUpdateRequest(data)
        setCurrentStep(data?.current_step)
      }
      if (!data) {
        navigate("/dashboard")
      }
    } catch (error) {}
  }

  const getKycData = async () => {
    try {
      const { success, data } = await getResult().unwrap()
      if (success) {
        setKycData(data)
      }
    } catch (error) {}
  }

  return (
    <>
      <div className="page-content">
        <div className="container-fluid pb-6">
          <div className="mb-5">
            <CardTitle className="mb-4 pt-4">Update Profile</CardTitle>
            {updateRequest && (
              <UpdateProfileProgressBar
                updateSteps={updateRequest?.steps}
                currentStep={currentStep}
              />
            )}
          </div>

          {(isFetching || isGetting) && <LoaderComponent />}
          {(!isFetching || !isGetting) && kycData && (
            <div
              className={`pb-md-5 ${
                currentStep !== "FINAL_STEP" ? "container-wrapper" : ""
              }`}
            >
              {currentStep === "PAN_GST" && (
                <CompanyDetails
                  currentStep={currentStep}
                  kycData={kycData}
                  profileData={updateRequest}
                  updateSteps={updateRequest?.steps}
                />
              )}

              {currentStep === "ADDITIONAL_DETAILS" && (
                <AdditionalDetails
                  currentStep={currentStep}
                  kycData={kycData}
                  profileData={updateRequest}
                  updateSteps={updateRequest?.steps}
                />
              )}

              {currentStep === "BUSINESS_ADDITIONAL_DETAILS" && (
                <BusinessAdditionalDetails
                  currentStep={currentStep}
                  kycData={kycData}
                  profileData={updateRequest}
                  updateSteps={updateRequest?.steps}
                />
              )}
              {["BANK_VERIFICATION", "BANK_DETAILS"].includes(currentStep) && (
                <BankDetails
                  currentStep={currentStep}
                  kycData={kycData}
                  profileData={updateRequest}
                  updateSteps={updateRequest?.steps}
                />
              )}

              {currentStep === "ID_VERIFICATION" &&
                user.entity_type === "INDIVIDUAL" && (
                  <IDVerification
                    currentStep={currentStep}
                    kycData={kycData}
                    profileData={updateRequest}
                    updateSteps={updateRequest?.steps}
                  />
                )}

              {currentStep === "AUTHORITY_LETTER" && (
                <KycAuthorityLetter
                  currentStep={currentStep}
                  kycData={kycData}
                  profileData={updateRequest}
                  updateSteps={updateRequest?.steps}
                />
              )}

              {/* {currentStep === "SIGNATURE" && (
                <Signature
                  currentStep={currentStep}
                  kycData={kycData}
                  profileData={updateRequest}
                  updateSteps={updateRequest?.steps}
                />
              )} */}
              {currentStep === "PHOTO" && (
                <CaptureSelfie
                  currentStep={currentStep}
                  kycData={kycData}
                  profileData={updateRequest}
                  updateSteps={updateRequest?.steps}
                />
              )}
              {["ID_VERIFICATION", "AUTHORISED_SIGNATORY"].includes(
                currentStep
              ) &&
                user.entity_type === "COMPANY" && (
                  <AuthorisedSignatory
                    currentStep={currentStep}
                    kycData={kycData}
                    profileData={updateRequest}
                    updateSteps={updateRequest?.steps}
                  />
                )}

              {currentStep === "FINAL_STEP" &&
                user.entity_type === "INDIVIDUAL" && (
                  <KycFinalStep
                    currentStep={currentStep}
                    kycData={kycData}
                    profileData={updateRequest}
                    updateSteps={updateRequest?.steps}
                  />
                )}

              {currentStep === "FINAL_STEP" &&
                user.entity_type === "COMPANY" && (
                  <KycFinalStepBusiness
                    currentStep={currentStep}
                    kycData={kycData}
                    profileData={updateRequest}
                    updateSteps={updateRequest?.steps}
                  />
                )}

              {currentStep === "SUBMITTED" && <KYCComplete />}
            </div>
          )}
        </div>
        {/* <Container fluid> */}
        {/* <React.Fragment>
            <div
              className={
                "py-5 d-flex flex-column align-items-center justify-content-between"
              }
            >
              <img
                src={comingSoon}
                style={{
                  maxWidth: "300px",
                }}
                alt="Record not found"
              />
              <h4
                style={{
                  color: "#000000",
                  fontSize: "32px",
                  fontWeight: "600",
                  marginTop: "15px",
                  marginBottom: "5px",
                }}
              >
                {`Coming Soon`}
              </h4>
              <p
                style={{
                  color: "#000000",
                  fontSize: "16px",
                }}
              >
                {`The page you're looking for will coming soon`}
              </p>

              <div className="buttons">
                <Link to={"/dashboard"}>
                  <Button type="button" className="primary">
                    Return to Dashboard
                  </Button>
                </Link>
              </div>
            </div>
          </React.Fragment> */}
        {/* </Container> */}
      </div>
    </>
  )
}

export default ProfileUpdate
